import React, { useEffect, useState } from 'react';
import { useTranslation} from 'react-i18next';
import helpers from "../../../Utils/helpers";
import {DropDownToggle} from "../../DropDownToggle";
import moment from "moment";
import EducationInfoModal from "./EducationInfoModal";
import useModal from "../../../Hooks/useModal";
import Modals from "../../../Constants/modals";
import EducationModal from "../../../Containers/Customer/Educations/EducationModal";
import {useDispatch, useSelector} from "react-redux";
import {bindActionCreators} from "redux";
import customerActionsImp from "../../../Actions/customerActions";
import Spinner from "../../Fundamentals/Spinner/Spinner";
import ToolTip, {TooltipContent, TooltipTrigger} from "../../Overlays/Tooltip";
import {Button} from "../../Fundamentals/Button";
import SkynetIcon from "../../Fundamentals/SkynetIcon";

const buttonFilterOptions = {
    All: 0,
    Paid: 1,
    Free: 2,
    ELearning: 3
}
export default function CourseList({filters, educations}) {
    const {openModal} = useModal();
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [subjects, setSubjects] = useState([])
    const [locations, setLocations] = useState([])
    const [buttonFilter, setButtonFilter] = useState(buttonFilterOptions.All);
    const [activeModal, setActiveModal] = useState();
    const [eventId, setEventId] = useState();
    const customerActions = bindActionCreators(customerActionsImp, dispatch);
    const {isModalOpen} = useModal();

    useEffect(() => {
        if (filters)
            resetFilters();
    }, [filters]);

    const resetFilters = () => {
        // sets filters from props to local state
        setSubjects(filters.subjects.map(item => ({
            label: item,
            selected: false
        })));

        setLocations(filters.locations.map(item => ({
            label: item,
            selected: false
        })))

        setButtonFilter(buttonFilterOptions.All);
    }

    const filterEducations = () => {
        const locationFilter = locations.filter(s => s.selected).map(m => m.label);
        const subjectFilter = subjects.filter(s => s.selected).map(m => m.label);

        if (locationFilter.length)
            educations = educations.filter(e => locationFilter.includes(e.location));

        if (subjectFilter.length)
            educations = educations.filter(e => e.subjects.some(f => subjectFilter.includes(f)));

        if (buttonFilter === buttonFilterOptions.Paid)
            educations = educations.filter(e => e.price > 0);
        else if (buttonFilter === buttonFilterOptions.Free)
            educations = educations.filter(e => e.price === 0);
        else if (buttonFilter === buttonFilterOptions.ELearning)
            educations = educations.filter(e => e.onDemand);

        return educations;
    }

    const onClickAction = (education) => {
        customerActions.getCourse(education.courseTemplateId);
        setEventId(education.id);
        openModal(Modals.EducationModal);
    }

    if (!educations?.length)
        return <Spinner/>

    const subjectOnChange = (item) => {
        const subject = subjects.find(s => s.label === item.label);
        subject.selected = !subject.selected
        setSubjects([...subjects]);
    }

    const locationOnChange = (item) => {
        const element = locations.find(s => s.label === item.label);
        element.selected = !element.selected
        setLocations([...locations]);
    }

    const hasFilter = () => {
        return locations.some(s => s.selected) || subjects.some(s => s.selected) || buttonFilter !== buttonFilterOptions.All;
    }

    const toggleModal = (modalName) => {
        setActiveModal(modalName)
    }

    const sendInfoEmail = (e, education) => {
        e.stopPropagation();
        customerActions.getCourse(education.courseTemplateId);
        toggleModal('showEducationInfoModal');
    };


    return <div>
        <button className={`btn btn-default${buttonFilter === buttonFilterOptions.All ? " btn-primary" : ""}`}
                onClick={() => setButtonFilter(buttonFilterOptions.All)}>{t('educations.allcourses')}
        </button>
        <button className={`btn btn-default${buttonFilter === buttonFilterOptions.ELearning ? " btn-primary" : ""}`}
                onClick={() => setButtonFilter(buttonFilterOptions.ELearning)}>{t('educations.elearning')}
        </button>
        <button className={`btn btn-default${buttonFilter === buttonFilterOptions.Paid ? " btn-primary" : ""}`}
                onClick={() => setButtonFilter(buttonFilterOptions.Paid)}>{t('educations.courseswithcost')}
        </button>
        <button className={`btn btn-default${buttonFilter === buttonFilterOptions.Free ? " btn-primary" : ""}`}
                onClick={() => setButtonFilter(buttonFilterOptions.Free)}>{t('educations.freecourses')}
        </button>
        <button className="btn btn-default" disabled={!hasFilter()} onClick={resetFilters}>{t('common.clear')}</button>
        <table className="table table-stripe table-hover px-32">
            <thead>
            <tr>
                <th className="text-left">{t('common.name')}</th>
                <th className="text-left"><DropDownToggle buttonLabel={t('educations.category')} items={subjects}
                                                          itemOnClick={subjectOnChange}/></th>
                <th className="text-left"><DropDownToggle buttonLabel={t('educations.location')} items={locations}
                                                          itemOnClick={locationOnChange}/></th>
                <th className="text-left">{t('common.startdate')}</th>
                <th className="text-left">{t('common.enddate')}</th>
                <th className="text-left">{t('educations.participantsbooked')}</th>
                <th className="text-left">{t('educations.minimumparticipants')}</th>
                <th className="text-left">{t('educations.maximumparticipants')}</th>
                <th className="text-left">{t('common.price')}</th>
                <th className="text-left"></th>
            </tr>
            </thead>
            <tbody>
            {filterEducations().map((education, index) => {
                let hasInfo = education.bookingInfo > 0
                let hasError = education.bookingInfo > 20;
                return <tr className={`${hasError ? "hasError" : "cursorpointer"}`}
                           onClick={hasError ? undefined : () => onClickAction(education)} key={index}>
                    <td>{hasInfo && <span className="indent-error">
                        <ToolTip placement={'left'} arrowPlacement={'right in'}>
                                <TooltipTrigger>
                                    <span
                                        className={`vismaicon vismaicon-sm vismaicon-filled vismaicon-${hasError ? 'error' : 'warning'}`}></span>
                                </TooltipTrigger>
                                <TooltipContent>
                                    <div>{getEducationInfoMsg(education, t)}</div>
                                </TooltipContent>
                            </ToolTip>
                    </span>}
                        {education.name}</td>
                    <td>{education.subjects && education.subjects.join(', ')}</td>
                    <td>{education.location}</td>
                    <td style={{whiteSpace: "nowrap"}}>{education.onDemand ? t('educations.frombooking') : education.date}</td>
                    <td style={{whiteSpace: "nowrap"}}>{education.onDemand ?  + education.onDemandAccessDays + t('educations.daysafterbooking') : education.endDate}</td>
                    <td> {education.participantsBooked}</td>
                    <td className={education.bookingInfo === 3 ? "text-danger" : ""}>{education.onDemand ? '-' : education.minimumParticipants}</td>
                    <td>{education.onDemand ? '-' : education.maximumParticipants}</td>
                    <td>{helpers.currencyFormatter(education.price)}</td>
                    <td><SkynetIcon icon="vismaicon-email m-0" title={t('educations.sendinfo')} onClick={(e) => sendInfoEmail(e, education)} disabled={hasError} /></td>
                </tr>
            })}
            </tbody>
        </table>
        {activeModal === 'showEducationInfoModal' && <EducationInfoModal togglemodal={toggleModal}/>}
        {isModalOpen(Modals.EducationModal) && <EducationModal eventId={eventId}/>}
    </div>
}

export const getEducationInfoMsg = (education, t) => {
    const info = education.bookingInfo

    if (info === 1) {
        return t('educations.minimumparticipantsnotreached');
    }

    if (info === 2) {
        return t('educations.enddatewithin35days');
    }

    if (info === 21) {
        return `${t('educations.educationisfull')}. ${t('educations.contactadministration')}`;
    }

    if (info === 22) {
        return `${t('educations.lastapplication')}. ${t('educations.contactadministration')}`;
    }

    if (info === 23) {
        return `${t('educations.coursestarttomorrow')}. ${t('educations.contactadministration')}`;
    }
}